// extracted by mini-css-extract-plugin
export default {"module":"module___cZ_M","adviceColumnContainer":"adviceColumnContainer__VBPHi"};